<template>
  <div class="container">
    <div class="c-contest-rules">
      <div class="block p-t-b">
        <main-image-section />
        <dynamic-link :type="tpl"></dynamic-link>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import DynamicLink from "../components/DynamicLink"
import MainImageSection from "../components/Layout/MainImageSection"

const { mapState } = createNamespacedHelpers("app")

export default {
  name: "ContestRules",
  components: {
    DynamicLink,
    MainImageSection
  },
  computed: {
    ...mapState(["lang"]),
    tpl() {
      return `rules_${this.lang}`
    }
  }
}
</script>
